import { createVirtualPortalHub, VirtualPortal } from 'react-virtual-portals';

interface Props {
    className?: string;
}

/**
 * Virtual portal hub for the Crud system.
 *
 * Note that any use of 'Head' will override both 'Heading' and 'Header'.
 */
const CrudHub = createVirtualPortalHub<
    'Head',    Props,
    'Header',  Props,
    'Heading', Props,
    'Body',    Props,
    'Foot',    Props
>(
    'Head',
    'Header',
    'Heading',
    'Body',
    'Foot'
);

export default CrudHub;
